import { createBrowserRouter, Navigate } from "react-router-dom";
import { AdminLayout } from "./components/layout/AdminLayout.jsx";
import { ProtectedRoute } from "./components/layout/ProtectedRoute.jsx";

import LoginPage from "./pages/LoginPage.jsx";
import ForgotPasswordPage from "./pages/ForgotPasswordPage.jsx";
import ResetPasswordPage from "./pages/ResetPasswordPage.jsx";
import DashboardPage from "./pages/DashboardPage.jsx";
import NotFoundPage from "./pages/NotFoundPage.jsx";

// Resource pages
import DesignsListPage from "./pages/designs/DesignsListPage.jsx";
import DesignFormPage from "./pages/designs/DesignFormPage.jsx";
import SmartUploadPage from "./pages/designs/SmartUploadPage.jsx";
import FacadesPage from "./pages/facades/FacadesPage.jsx";
import BulkImportFacadesPage from "./pages/facades/BulkImportFacadesPage.jsx";
import FloorPlansPage from "./pages/floor-plans/FloorPlansPage.jsx";
import BulkImportFloorPlansPage from "./pages/floor-plans/BulkImportFloorPlansPage.jsx";
import GalleryPage from "./pages/gallery/GalleryPage.jsx";
import BulkImportGalleryPage from "./pages/gallery/BulkImportGalleryPage.jsx";
import DisplayHomesPage from "./pages/display-homes/DisplayHomesPage.jsx";
import DisplayHomeFormPage from "./pages/display-homes/DisplayHomeFormPage.jsx";
import HouseLandPage from "./pages/house-land/HouseLandPage.jsx";
import HouseLandFormPage from "./pages/house-land/HouseLandFormPage.jsx";
import ServicesPage from "./pages/services/ServicesPage.jsx";
import ServiceFormPage from "./pages/services/ServiceFormPage.jsx";
import BlogCategoriesPage from "./pages/blog-categories/BlogCategoriesPage.jsx";
import BlogsListPage from "./pages/blogs/BlogsListPage.jsx";
import BlogFormPage from "./pages/blogs/BlogFormPage.jsx";
import AwardsPage from "./pages/awards/AwardsPage.jsx";
import AwardFormPage from "./pages/awards/AwardFormPage.jsx";
import TeamPage from "./pages/team/TeamPage.jsx";
import TeamFormPage from "./pages/team/TeamFormPage.jsx";
import TestimonialsPage from "./pages/testimonials/TestimonialsPage.jsx";
import TestimonialFormPage from "./pages/testimonials/TestimonialFormPage.jsx";
import FormSubmissionsPage from "./pages/forms/FormSubmissionsPage.jsx";
import ProfilePage from "./pages/profile/ProfilePage.jsx";
import SettingsPage from "./pages/settings/SettingsPage.jsx";
import UsersPage from "./pages/users/UsersPage.jsx";
import ActivityLogsPage from "./pages/activity-logs/ActivityLogsPage.jsx";

export const router = createBrowserRouter([
  // Public
  { path: "/login", element: <LoginPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },

  // Protected
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <DashboardPage /> },

          // Catalogue
          { path: "designs", element: <DesignsListPage /> },
          // Smart Upload route MUST come before "designs/:id" so the
          // router doesn't treat "smart-upload" as an :id.
          { path: "designs/smart-upload", element: <SmartUploadPage /> },
          { path: "designs/new", element: <DesignFormPage /> },
          { path: "designs/:id", element: <DesignFormPage /> },
          { path: "facades", element: <FacadesPage /> },
          { path: "facades/new", element: <FacadesPage /> }, // modal opens via ?new=1 (no-op for now)
          { path: "facades/bulk-import", element: <BulkImportFacadesPage /> },
          { path: "floor-plans", element: <FloorPlansPage /> },
          { path: "floor-plans/bulk-import", element: <BulkImportFloorPlansPage /> },
          { path: "gallery", element: <GalleryPage /> },
          { path: "gallery/bulk-import", element: <BulkImportGalleryPage /> },
          { path: "display-homes", element: <DisplayHomesPage /> },
          { path: "display-homes/new", element: <DisplayHomeFormPage /> },
          { path: "display-homes/:id", element: <DisplayHomeFormPage /> },
          { path: "house-land", element: <HouseLandPage /> },
          { path: "house-land/new", element: <HouseLandFormPage /> },
          { path: "house-land/:id", element: <HouseLandFormPage /> },

          // Content
          { path: "services", element: <ServicesPage /> },
          { path: "services/new", element: <ServiceFormPage /> },
          { path: "services/:id", element: <ServiceFormPage /> },
          { path: "blog-categories", element: <BlogCategoriesPage /> },
          { path: "blogs", element: <BlogsListPage /> },
          { path: "blogs/new", element: <BlogFormPage /> },
          { path: "blogs/:id", element: <BlogFormPage /> },

          // About
          { path: "awards", element: <AwardsPage /> },
          { path: "awards/new", element: <AwardFormPage /> },
          { path: "awards/:id", element: <AwardFormPage /> },
          { path: "team", element: <TeamPage /> },
          { path: "team/new", element: <TeamFormPage /> },
          { path: "team/:id", element: <TeamFormPage /> },
          { path: "testimonials", element: <TestimonialsPage /> },
          { path: "testimonials/new", element: <TestimonialFormPage /> },
          { path: "testimonials/:id", element: <TestimonialFormPage /> },

          // Inbox + Profile
          { path: "forms", element: <FormSubmissionsPage /> },
          { path: "profile", element: <ProfilePage /> },
        ],
      },
      // Super-admin-only system pages
      {
        element: <ProtectedRoute superAdminOnly />,
        children: [
          {
            element: <AdminLayout />,
            children: [
              { path: "settings", element: <SettingsPage /> },
              { path: "users", element: <UsersPage /> },
              { path: "activity-logs", element: <ActivityLogsPage /> },
            ],
          },
        ],
      },
    ],
  },

  { path: "/404", element: <NotFoundPage /> },
  { path: "*", element: <Navigate to="/" replace /> },
]);
